import { clsx } from 'clsx'
import { type CSSProperties, type ReactElement, type ReactNode } from 'react'

import type { MaxColumnsPerRow, MinColumnsPerRow } from '@contentful-types/section-multi-column'

import { ImageContext } from '@contexts/image-context'

import type { LayoutColumn } from '@components/layout/types'

import styles from './multi-column.module.scss'

interface MultiColumnLayoutProps {
  children?: ReactNode
  maxColumnsPerRow: MaxColumnsPerRow
  withDivider?: boolean
  minColumnsPerRow?: MinColumnsPerRow
  multiColumnAsSingle?: boolean
  compact?: boolean
}

export function MultiColumnLayout({
  children,
  withDivider,
  multiColumnAsSingle,
  maxColumnsPerRow = 2,
  minColumnsPerRow = maxColumnsPerRow,
  compact,
}: MultiColumnLayoutProps): ReactElement {
  const layoutStyles = {
    '--multiColumnMaxColumnsPerRow': maxColumnsPerRow,
    '--multiColumnMinColumnsPerRow': minColumnsPerRow ?? maxColumnsPerRow,
  } as CSSProperties

  const layoutClass = clsx(styles.multiColumn, {
    [styles.multiColumnWithDivider]: withDivider,
  })

  const content = (
    <div
      style={layoutStyles}
      className={clsx(layoutClass, {
        [styles.multiColumnAsSingle]: multiColumnAsSingle,
        [styles.multiColumn]: !multiColumnAsSingle,
        [styles.multiColumnCompact]: compact,
      })}
    >
      <ImageContext.Provider value={{ cols: (12 / maxColumnsPerRow) as LayoutColumn }}>
        {children}
      </ImageContext.Provider>
    </div>
  )
  return multiColumnAsSingle ? <div className={styles.wrapper}>{content}</div> : content
}
